import http from '../api/axios';

export const getVipList = (params) => {
    return http.post('/api/vip/viplist',params);
};
export const submitPay = (params) => {
    return http.post('/api/pay/submit',params);
};
export const getVipRecords = (params) => {
    return http.post('/api/vip/record',params);
};



// WEBPACK FOOTER //
// ./src/api/vip.js